import { useState } from "react";
import { useBoard } from "@/lib/boardStore";
import { ChevronDown, ChevronUp, Tag } from "lucide-react";

export default function Legend({ onManageCategories }) {
  const { categories } = useBoard();
  const [open, setOpen] = useState(true);

  return (
    <div
      className="absolute bottom-4 left-4 z-30 max-w-[240px]"
      data-testid="category-legend"
    >
      <div className="bg-[#1a140c]/90 backdrop-blur-md border border-[#5c4426]/50 rounded-md shadow-[0_8px_28px_rgba(0,0,0,0.6)] overflow-hidden">
        <button
          data-testid="legend-toggle-btn"
          onClick={() => setOpen((v) => !v)}
          className="w-full flex items-center justify-between px-3 py-2 text-[#f4d9a8] hover:bg-[#5c4426]/30 transition-colors"
        >
          <span className="flex items-center gap-2">
            <Tag size={12} className="text-[#c9702a]" />
            <span className="noir-title text-sm tracking-wide">Legend</span>
          </span>
          {open ? <ChevronDown size={14} /> : <ChevronUp size={14} />}
        </button>
        {open && (
          <div
            data-testid="legend-body"
            className="px-3 pt-1 pb-3 border-t border-[#5c4426]/30"
          >
            {categories.length === 0 && (
              <div className="typewriter text-[10px] text-[#c9b285]/50 italic py-1">
                No categories yet.
              </div>
            )}
            <ul className="space-y-1.5 py-1">
              {categories.map((c) => (
                <li
                  key={c.id}
                  data-testid={`legend-item-${c.id}`}
                  className="flex items-center gap-2"
                >
                  <span
                    className="inline-block w-3 h-3 rounded-full shrink-0"
                    style={{
                      background: c.color,
                      boxShadow:
                        "inset -1px -1.5px 2px rgba(0,0,0,0.4), inset 1px 1px 1.5px rgba(255,255,255,0.35)",
                    }}
                  />
                  <span
                    className="typewriter text-[12px] truncate"
                    style={{ color: c.color }}
                    title={c.name}
                  >
                    {c.name}
                  </span>
                </li>
              ))}
            </ul>
            {onManageCategories && (
              <button
                data-testid="legend-manage-btn"
                onClick={onManageCategories}
                className="mt-2 w-full text-[10px] uppercase tracking-widest typewriter text-[#c9b285]/70 hover:text-[#f4d9a8] text-left"
              >
                Manage ›
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
